const globalAlertMixin = {
  methods: {
    launchAlert: function (options) {
      this.$notify(options)
    }
  }
}

export default globalAlertMixin
